import { reducer as customers, namespace as customersNamespace } from './customers';
import { reducer as customerDetails, namespace as customerDetailsNamespace } from './customerDetails';
import { reducer as overview, namespace as overviewNamespace } from './customerDetails/overview';
import { reducer as receipts, namespace as receiptsNamespace } from './customerDetails/receipts';
import { reducer as receipt, namespace as receiptNamespace } from './customerDetails/receipt';
import { reducer as addresses, namespace as addressesNamespace } from './customerDetails/addresses';
import { reducer as discounts, namespace as discountsNamespace } from './customerDetails/discounts';
import { reducer as company, namespace as companyNamespace } from './customerDetails/company';
import { reducer as attributes, namespace as attributesNamespace } from './customerDetails/attributes';

export interface State {
    [customersNamespace]: customers.State;
    [customerDetailsNamespace]: customerDetails.State;
    [overviewNamespace]: overview.State;
    [receiptsNamespace]: receipts.State;
    [receiptNamespace]: receipt.State;
    [discountsNamespace]: discounts.State;
    [addressesNamespace]: addresses.State;
    [companyNamespace]: company.State;
    [attributesNamespace]: attributes.State;
}

export const initialState: State = {
    [customersNamespace]: customers.initialState,
    [customerDetailsNamespace]: customerDetails.initialState,
    [overviewNamespace]: overview.initialState,
    [receiptsNamespace]: receipts.initialState,
    [receiptNamespace]: receipt.initialState,
    [discountsNamespace]: discounts.initialState,
    [addressesNamespace]: addresses.initialState,
    [companyNamespace]: company.initialState,
    [attributesNamespace]: attributes.initialState,
};

export const reducers = {
    [customersNamespace]: customers.reducer,
    [customerDetailsNamespace]: customerDetails.reducer,
    [overviewNamespace]: overview.reducer,
    [receiptsNamespace]: receipts.reducer,
    [receiptNamespace]: receipt.reducer,
    [discountsNamespace]: discounts.reducer,
    [addressesNamespace]: addresses.reducer,
    [companyNamespace]: company.reducer,
    [attributesNamespace]: attributes.reducer,
};
